import UnitInputPage from "@components/UnitInputPage"

export default function Weight() {
  return (
    <UnitInputPage
      translationKey="weight"
      metricUnit={{
        value: "kg",
        label: "kg",
        placeholder: "65",
        conversionFactor: 1,
      }}
      imperialUnit={{
        value: "lb",
        label: "lb",
        placeholder: "143",
        conversionFactor: 0.453592,
      }}
    />
  )
}
